<template>
  <b-form-group
    :label="$t(propName, { value: currentState[propName] })"
    label-for="ct"
  >
    <b-form-input id="ct"
                  type="range"
                  v-model.number="currentState[propName]"
                  :min="currentImageEnhancement.min"
                  :max="currentImageEnhancement.max"
                  :step="currentImageEnhancement.step"/>
  </b-form-group>
</template>

<script>
  import { IMAGE_ENHANCEMENTS } from './consts';

  export default {
    name: 'Slider',
    props: {
      currentState: {
        type: Object,
        required: true
      },
      propName: {
        type: String,
        required: true
      }
    },
    computed: {
      currentImageEnhancement () {
        return IMAGE_ENHANCEMENTS[this.propName];
      }
    }
  };
</script>

<style scoped>

</style>
